import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {

    "TimesheetSingleTileContainer": () => import("./components/TimesheetSingleTileContainer.vue"),  //General single tile container
    "TimesheetsListTile": () => import ("./components/tiles/TimesheetsListTile.vue"),               //Tile that contains the list of registers
    "NewTimesheetRegisterTile": () => import ("./components/tiles/NewTimesheetRegisterTile.vue"),   //Tile that contains the new register creation component
    "EditTimesheetRegisterTile": () => import ("./components/tiles/EditTimesheetRegisterTile.vue"),   //Tile that contains the edit register component
    "TimesheetDetailsTile": () => import ("./components/tiles/TimesheetDetailsTile.vue"),           //Tile that contains the details of a specific timesheet

};

export default globals;
